import { ApiSmpArtGallery } from "@smp/api";
import { Await } from "@smp/utils";
import { useInfiniteQuery } from "react-query";
import { UseInfiniteQueryOptions } from "react-query/types/react/types";

import { useContextApp } from "@/screens/app/context/app";
import { gscSendUserParams } from "@/utils";

const KEY_POLOTNO_USER_TEMPLATES = "polotno.user_templates";

export const useQueryPolotnoUserTemplates = (
  params: Parameters<typeof ApiSmpArtGallery.Polotno.userTemplates>[0],
  options?: Omit<
    UseInfiniteQueryOptions<
      Await<ReturnType<typeof ApiSmpArtGallery.Polotno.userTemplates>>
    >,
    "queryKey" | "queryFn" | "getNextPageParam"
  >,
) => {
  const {
    state: { organizationId },
  } = useContextApp();

  return useInfiniteQuery<
    Await<ReturnType<typeof ApiSmpArtGallery.Polotno.userTemplates>>
  >(
    [KEY_POLOTNO_USER_TEMPLATES, organizationId, { params }],
    ({ pageParam }) =>
      ApiSmpArtGallery.Polotno.userTemplates(params, pageParam),
    {
      getNextPageParam: (response) => response.next || undefined,
      ...(options || {}),
      onSuccess: (...args) => {
        const [data] = args;

        if (data.pages.length === 1) {
          gscSendUserParams({
            polotno: data.pages[0].results.length > 0,
          });
        }

        options?.onSuccess?.(...args);
      },
    },
  );
};

useQueryPolotnoUserTemplates.KEY = KEY_POLOTNO_USER_TEMPLATES;
